/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import propTypes from 'prop-types';
import { Popover } from 'react-tiny-popover';
import { useState } from 'react';
import { MathJax } from 'better-react-mathjax';

import Popup from './Popup';

import * as examHelper from 'utils/exam';
import clsx from 'libs/clsx';
import Typography from 'components/Typography';
import { safeJoinURL } from 'libs/url';
import useBaseURL from 'hooks/useBaseURL';

const Container = ({ answer, choices, onAnswerChange }) => {
  const path = useBaseURL();

  // Indikator apakah popover muncul atau tidak.
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  // Menutup popover saat menjawab.
  const handleAnswerChange = (...args) => {
    onAnswerChange(...args);
    setIsPopoverOpen(false);
  };

  const togglePopover = () => setIsPopoverOpen((current) => !current);

  return (
    <div className="inline-block">
      <Popover
        isOpen={isPopoverOpen}
        positions={['bottom', 'left', 'top', 'right']}
        padding={10}
        onClickOutside={() => setIsPopoverOpen(false)}
        content={({ position, childRect, popoverRect }) => (
          <Popup
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            choices={choices}
            onAnswerChange={handleAnswerChange}
          />
        )}
      >
        {examHelper.isImage(answer) ? (
          <img
            className="h-full max-w-12 max-h-24 select-none cursor-pointer inline-block bg-blue-100 p-1 rounded-lg border-dashed border-2 border-blue-500"
            src={safeJoinURL(path.questionImage, answer)}
            alt={answer}
            onClick={togglePopover}
          />
        ) : (
          <Typography
            as="div"
            className={clsx(
              'select-none cursor-pointer inline-block bg-blue-100 p-1 rounded-lg border-dashed border-2 border-blue-500',
              answer ? 'font-bold' : 'text-gray-500',
              /[\u0600-\u06FF]/.test(answer) && 'arabic'
            )}
            onClick={togglePopover}
          >
            {answer ? (
              <MathJax>
                {/* eslint-disable-next-line react/no-danger */}
                <span dangerouslySetInnerHTML={{ __html: answer }} />
              </MathJax>
            ) : (
              'Pilih jawaban'
            )}
          </Typography>
        )}
      </Popover>
    </div>
  );
};

Container.defaultProps = {
  answer: null,
};

Container.propTypes = {
  answer: propTypes.string,
  choices: propTypes.arrayOf(propTypes.string).isRequired,
  onAnswerChange: propTypes.func.isRequired,
};

export default Container;
